import { ReactNode } from "react";
import "./AdminBreadcrumbs.css";

const AdminBreadcrumbs = ({ children }: { children: ReactNode }) => {
  return <nav className="AdminBreadcrumbs">{children}</nav>;
};

export default AdminBreadcrumbs;
